// ImageUpload.tsx
import React from 'react';
import FileUpload from '../../../../../../component-controller-mod/component-serv/card-fs-cp/upload-card-op/ts/fileUpload';  // Adjust path if needed
import LabelRow from './labelRow';
const FileIcon = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
    <rect x="3.25" y="7.58" width="19.5" height="13.52" rx="2" stroke="#323539" strokeWidth="1.5"/>
    <path d="M8.67 7.58V6.5a1.5 1.5 0 013 0v1.08" stroke="#323539" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M14.33 7.58V6.5a1.5 1.5 0 013 0v1.08" stroke="#323539" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

interface ImageUploadProps {
  label:        string;
  currentSrc?:  string;
  currentName?: string;
  onFile:       (f: File) => void;
}

const ImageUpload: React.FC<ImageUploadProps> = ({ label, currentSrc, currentName, onFile }) => (
  <div className="cse-upload-block">
    <LabelRow label={label} />  {/* Import LabelRow if not in the same file */}
    <div className="cse-upload-row">

      {/* Current file preview — always shown */}
      <div className="cse-upload-current">
        {currentSrc
          ? <img src={currentSrc} alt={currentName} className="cse-upload-thumb"
              onError={e => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }} />
          : <div className="cse-upload-thumb"><FileIcon /></div>
        }
        <div className="cse-upload-meta">
          <span className="cse-upload-name">{currentName ?? 'No file selected'}</span>
          <span className="cse-upload-size">5 MB of 12MB</span>
        </div>
      </div>

      {/* FileUpload component as the upload zone */}
      <FileUpload
        accept=".jpg,.jpeg,.png,.svg"
        supportText="JPG, PNG or SVG"
        onFilesSelected={files => { if (files[0]) onFile(files[0]); }}
        className="cse-upload-zone"
      />

    </div>
  </div>
);

export default ImageUpload;